import React, { useContext } from "react";
import LogoMpsr from "assets/images/LogoMPSR.png";
import MplogoLowVision from "assets/images/LogoMPSR_LowVision.svg";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    className?: string;
    lowVision?: boolean;
}

export const AccountHeader: React.FC<Props> = ({ className }) => {
    const { lowVision } = useContext(AccessibilityContext);
    const logoMP = lowVision ? MplogoLowVision : LogoMpsr;

    return (
        <header className={className}>
            <img
                src={logoMP}
                alt=""
                className={lowVision ? "account-logo--low-vision" : undefined}
            />
        </header>
    );
};
